module.exports = __webpack_public_path__ + "8dfd4e8b82a37da70f1ff74c33b2a419.pdf";